export enum TASK_TYPE {
    FSP_WORK_GROUP_TASK = 1,
    FSP_ANALYSIS_TASK = 2,
    TEAM_TASK = 3,
    MONITORING_TASK = 4,
    TRACEABILITY_TASK = 5,
}
